import React, { Component } from 'react';
import { Collapse, Row, Col } from 'react-bootstrap';
import classNames from 'classnames';
import { Link } from 'react-router-dom';
import EditBirthdayForm from './EditBirthdayForm';
import EditPasswordForm from './EditPasswordForm';
import NameAndEmailForm from './NameAndEmailForm';
import SecondaryContactForm from './SecondaryContactForm';
import moment from 'moment';

const formatPhoneNumber = require('../../../../utils/formatNumber').handler;

const getBillingAddressId = CreditCards => {
  const { AddressBookId } = (CreditCards || [])
    .find(({ IsDefault }) => IsDefault === true) || {};
  return AddressBookId;
};


const getAddressLabels = (
  {
    AddressBookID,
    IsDefaultMailing,
    IsDefaultShipping,
    IsClubAddress,
    clubBillingAddressId
  }
) => {
  const labels = [];
  if (IsDefaultMailing) labels.push('Primary Mailing');
  if (IsDefaultShipping) labels.push('Primary Shipping');
  if (IsClubAddress && clubBillingAddressId === AddressBookID)
    labels.push('Club Billing');
  if (IsClubAddress && clubBillingAddressId !== AddressBookID)
    labels.push('Club Shipping');

  return labels.join(', ');
};

class ProfileDetails extends Component {
  render() {
    const {
      active,
      toggle,
      user,
      handlePutBirthday,
      errorBirthday,
      handlePutPassword,
      errorPassword,
      deleteAddress,
      deleteCard,
      handlePostNameAndEmail,
      handlePostPatchSecondaryContact,
      deleteAddressError,
      deleteCardError,
      clearDeleteAddress,
      clearDeleteCard
    } = this.props;

    const {
      AddressBook,
      CreditCards,
      DOB,
      name_first,
      name_last,
      email,
      mobilePhone,
      secondaryContact,
      smsMarketingTW,
      smsTransactional,
      MailingPrefs
    } = user || {};
    const {
      twomey,
    } = MailingPrefs || {};
    const {
      name_first: sc_name_first,
      name_last: sc_name_last,
      email: sc_email,
      phone: sc_phone,
      relationship,
      sharedClubMembership,
      clubShipmentEmails,
      emailConfirmations } = secondaryContact || {}

    const cleanedMobilePhone = formatPhoneNumber(mobilePhone);

    const clubBillingAddressId = getBillingAddressId(CreditCards || []);

    //convert dob to seperate fields
    const dob = moment(DOB);
    const dob_year = dob.year();
    const dob_day = dob.date();
    const dob_month = dob.month();

    const handleDeleteAddress = AddressBookID =>
      () => deleteAddress(AddressBookID);
    const handleDeleteCard = CardId => () => deleteCard(CardId);
    const onPostNameAndEmail = payload => {
      const { IsDiscoveringTwomey } = payload || {};
      if (!!IsDiscoveringTwomey !== !!twomey) {
        payload.discoveryPreferences = [{ listKey: 'IsDiscoveringTwomey', value: IsDiscoveringTwomey }];
        payload.source = 'Twomey.com - Account Preferences';
      };
      handlePostNameAndEmail(payload);
    };
    const onPostPatchSecondaryContact = payload => handlePostPatchSecondaryContact(payload);

    return (
      <div className="col-products">
        <h1 className="smaller account-header no-bottom">Edit Profile</h1>
        <div className="accordion profile-cards" id="editProfile">
          <div className="card">
            <div className="card-header" id="headingOne">
              <button
                className={classNames(
                  'btn btn-collapse btn-link',
                  'name-and-email' !== active ? 'collapsed' : ''
                )}
                type="button"
                onClick={() => toggle('name-and-email')}
              >
                Name & Email
                <i className="fas fa-chevron-up" />
              </button>
            </div>
            <Collapse id="collapseOne" in={active === 'name-and-email'}>
              <div className="card-body">
                {active === 'name-and-email' &&
                  <NameAndEmailForm
                    toggle={toggle}
                    onSubmit={onPostNameAndEmail}
                    initialValues={{
                      name_first,
                      name_last,
                      email,
                      mobilePhone: cleanedMobilePhone,
                      smsMarketingTW,
                      smsTransactional,
                      IsDiscoveringTwomey: twomey
                    }}
                  />}
              </div>
            </Collapse>
          </div>
          <div className="card">
            <div className="card-header" id="headingOne">
              <button
                className={classNames(
                  'btn btn-collapse btn-link',
                  'secondary-contact' !== active ? 'collapsed' : ''
                )}
                type="button"
                onClick={() => toggle('secondary-contact')}
              >
                Secondary Contact
                <i className="fas fa-chevron-up" />
              </button>
            </div>
            <Collapse id="collapseOne" in={active === 'secondary-contact'}>
              <div className="card-body">
                {active === 'secondary-contact' &&
                  <SecondaryContactForm
                    toggle={toggle}
                    onSubmit={onPostPatchSecondaryContact}
                    initialValues={{
                      sc_name_first,
                      sc_name_last,
                      sc_email,
                      sc_phone,
                      relationship,
                      sharedClubMembership,
                      clubShipmentEmails,
                      emailConfirmations
                    }}
                  />}
              </div>
            </Collapse>
          </div>
          <div className="card">
            <div className="card-header" id="headingOne">
              <button
                className={classNames(
                  'btn btn-collapse btn-link',
                  'address-book' !== active ? 'collapsed' : ''
                )}
                type="button"
                onClick={() => {
                  clearDeleteAddress();
                  toggle('address-book');
                }}
              >
                Address Book
                <i className="fas fa-chevron-up" />
              </button>
            </div>
            <Collapse id="collapseOne" in={active === 'address-book'}>
              <div className="card-body">
                <div className="row">
                  {(AddressBook || []).map(({
                    AddressBookID,
                    Label,
                    Address1,
                    Address2,
                    City,
                    StateShort,
                    Zip,
                    IsClubAddress,
                    IsDefaultMailing,
                    IsDefaultShipping
                  }) => {
                    const isSpecial = IsDefaultMailing ||
                      IsDefaultShipping ||
                      IsClubAddress;
                    const canDelete = !IsClubAddress &&
                      !IsDefaultMailing &&
                      !IsDefaultShipping;
                    return (
                      <div
                        className="col-md-4"
                        style={{ marginBottom: '20px' }}
                        key={AddressBookID}
                      >
                        <p className="account-info-block">
                          <strong>
                            {isSpecial &&
                              <span>
                                {getAddressLabels({
                                  AddressBookID,
                                  IsDefaultMailing,
                                  IsDefaultShipping,
                                  IsClubAddress,
                                  clubBillingAddressId
                                })}
                              </span>}
                          </strong>
                          {Address1} {Address2} <br />
                          {City}, {StateShort} <br />
                          {Zip}
                          <Row>
                            <Col>
                              <Link
                                className="edit"
                                to={
                                  `/account/edit-profile/address-book/${AddressBookID}`
                                }
                              >
                                <em>Edit</em>
                              </Link>
                            </Col>
                            {canDelete &&
                              <Col>
                                <Link
                                  className="edit"
                                  onClick={handleDeleteAddress(AddressBookID)}
                                >
                                  <em>Delete</em>
                                </Link>
                              </Col>}
                          </Row>
                        </p>
                      </div>
                    );
                  })}
                </div>
                {deleteAddressError &&
                  <div className="form-row">
                    <span
                      style={{
                        color: '#dc3545',
                        marginLeft: '10px',
                        fontSize: '20px'
                      }}
                    >
                      An error occurred deleting address
                    </span>
                  </div>}

                <button
                  className="btn btn-primary btn-pad"
                  onClick={() => toggle('add-address')}
                >
                  Add New Address
                </button>
              </div>
            </Collapse>
          </div>
          <div className="card">
            <div className="card-header" id="headingTwo">
              <button
                className={classNames(
                  'btn btn-collapse btn-link',
                  'payment' !== active ? 'collapsed' : ''
                )}
                type="button"
                onClick={() => {
                  clearDeleteCard();
                  toggle('payment');
                }}
              >
                Payment
                <i className="fas fa-chevron-up" />
              </button>
            </div>
            <Collapse id="collapseTwo" in={active === 'payment'}>
              <div className="card-body">
                <div className="row">
                  {(CreditCards || [])
                    .filter(({ isAuthorized }) => isAuthorized)
                    .map(({
                      ExpirationMonth,
                      ExpirationYear,
                      LastFour,
                      CardId,
                      IsDefault,
                      AddressBookId
                    }) => {
                      const { FirstName, LastName } = (AddressBook || [])
                        .find(
                          ({ AddressBookID }) => AddressBookID === AddressBookId
                        ) || {};
                      return (
                        <div
                          className="col-md-4"
                          style={{ marginBottom: '20px' }}
                          key={CardId}
                        >
                          <p className="account-info-block">
                            <strong>
                              Payment
                              {IsDefault && ' - (Default)'}
                            </strong>
                            {FirstName} {LastName} <br />
                            ****-****-****-{LastFour} <br />
                            Exp: {ExpirationMonth}/{ExpirationYear} <br />
                            <Row>
                              <Col>
                                <Link
                                  className="edit"
                                  to={`/account/edit-profile/payment/${CardId}`}
                                >
                                  <em>Edit</em>
                                </Link>
                              </Col>
                              <Col>
                                {!IsDefault &&
                                  <Link
                                    className="edit"
                                    onClick={handleDeleteCard(CardId)}
                                  >
                                    <em>Delete</em>
                                  </Link>}
                              </Col>
                            </Row>
                          </p>
                        </div>
                      );
                    })}
                </div>
                {deleteCardError &&
                  <div className="form-row">
                    <span
                      style={{
                        color: '#dc3545',
                        marginLeft: '10px',
                        fontSize: '20px'
                      }}
                    >
                      An error occurred deleting card
                    </span>
                  </div>}
                <button
                  className="btn btn-primary btn-pad"
                  onClick={() => toggle('add-payment')}
                >
                  Add Payment
                </button>
              </div>
            </Collapse>
          </div>

          <div className="card">
            <div className="card-header" id="headingThree">
              <button
                className={classNames(
                  'btn btn-collapse btn-link',
                  'birthday' !== active ? 'collapsed' : ''
                )}
                type="button"
                onClick={() => toggle('birthday')}
              >
                Birthday
                <i className="fas fa-chevron-up" />
              </button>
            </div>
            <Collapse id="collapseThree" in={active === 'birthday'}>
              <div className="card-body">
                <EditBirthdayForm
                  toggle={toggle}
                  initialValues={{ dob_year, dob_day, dob_month }}
                  onSubmit={handlePutBirthday}
                  errorSubmit={errorBirthday}
                />
              </div>
            </Collapse>
          </div>
          <div className="card">
            <div className="card-header" id="headingFour">
              <button
                className={classNames(
                  'btn btn-collapse btn-link',
                  'password' !== active ? 'collapsed' : ''
                )}
                type="button"
                onClick={() => toggle('password')}
              >
                Password
                <i className="fas fa-chevron-up" />
              </button>
            </div>
            <Collapse id="collapseFour" in={active === 'password'}>
              <div className="card-body">
                <EditPasswordForm
                  toggle={toggle}
                  onSubmit={handlePutPassword}
                  errorSubmit={errorPassword}
                />
              </div>
            </Collapse>
          </div>
        </div>

      </div>
    );
  }
}

export default ProfileDetails;
